export default function SupportPresentIcon({ className = "", onClick = null }) {
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      className={`support-present-icon ${className}`}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="86 82 328 324"
    >
      <path d="M403.5,172.89h-38.12v-46.88c0-17.36-10.72-31.91-27.3-37.06-16.58-5.15-33.65.77-43.49,15.08l-44.59,64.9-44.59-64.9c-9.83-14.31-26.9-20.23-43.49-15.08-16.58,5.15-27.3,19.7-27.3,37.06v46.88h-38.12c-5.52,0-10,4.48-10,10v90c0,5.52,4.48,10,10,10h9v120c0,5.52,4.48,10,10,10h269c5.52,0,10-4.48,10-10v-120h9c5.52,0,10-4.48,10-10v-90c0-5.52-4.48-10-10-10ZM387.5,256.89h-124.5v-58h124.5v58ZM316.02,118.75c4.96-7.21,12.24-5.63,14.35-4.98,2.11.66,9.01,3.48,9.01,12.23v46.88h-60.55l37.2-54.13ZM160.62,126.01c0-8.75,6.89-11.57,9.01-12.23,2.11-.66,9.39-2.24,14.35,4.98l37.2,54.13h-60.55v-46.88ZM112.5,198.89h124.5v58h-124.5v-58ZM131.5,282.89h105.5v104h-105.5v-104ZM368.5,386.89h-105.5v-104h105.5v104Z" />
    </svg>
  );
}
